export default {
  title: {
    'zh-cn': '我的客户-设备管理',
    'zh-tw': '我的客戶-設備管理',
    'en': 'My Customer - Device Management'
  }
}

